import React, { useEffect, useState } from 'react';
import omMockUp from '../img/png/om_mock.png';
import platformLeft from '../img/png/platform_background_left.png';
import platformRight from '../img/png/platform_background_right.png';
// import { GlassMagnifier } from 'react-image-magnifiers';

function OurPlatform() {
  //scroll target
  const [target, setTarget] = useState('');

  useEffect(() => {
    if (target) {
      const location = document.querySelector(target);
      if (location)
        window.scrollTo({
          top: location.offsetTop - 30,
        });
    }
  }, [target]);

  const handleScrollTarget = (e) => {
    // e.preventDefault();
    if (target === e.target.getAttribute('href')) {
      const location = document.querySelector(target);
      if (location)
        window.scrollTo({
          top: location.offsetTop - 35,
        });
    }
    setTarget(e.target.getAttribute('href'));
  };

  return (
    <>
      <section
        id='onemarket'
        className='platform d-flex-col align-items-center justify-content-center'
      >
        <div className='platform_container d-flex-col align-items-center justify-content-center text-center'>
          <div className='platform_container_A'>
            <p className='text-primary'>OUR PLATFORM</p>
            <h2 className='text-title'>ONE Market</h2>
            <p className='text-subtitle'>
              The cookie-less, PII-free & GDPR compliant Ad-targeting solution
            </p>
          </div>
          <div className='platform_container_B'>
            <img src={omMockUp} alt="'ONE Market Platform'" />
            {/* <GlassMagnifier
              className='glass_magnify'
              imageSrc={omMockUp}
              imageAlt='ONE Market Platform'
              magnifierBorderColor='#eef2ff'
              magnifierSize='25%'
              magnifierBorderSize='4'
            /> */}
          </div>
          <div className='platform_container_C text-center d-flex-col gap-1 align-items-center justify-content-center text-center'>
            <p className='text-gray'>
              ONE Market is an end-to-end solution that seamlessly connects the
              right audience with the right digital destination, when and where
              online behaviours take place.
            </p>
            <p className='text-gray'>
              It solves one of the most difficult challenges of the internet:
              <br />
              why people fail to click or interact with ads.
            </p>
            <div className='highlight d-flex-col justify-content-between align-items-center'>
              <div></div>
              <div></div>
            </div>
          </div>
          <button href='#contact' onClick={handleScrollTarget}>
            Try it now
          </button>
        </div>
        <div className='platform_background d-flex-row justify-content-between'>
          <div className='platform_background_left d-flex-col flex-start'>
            <img src={platformLeft} alt='background' />
          </div>
          <div className='platform_background_right d-flex align-items-end'>
            <img src={platformRight} alt='background' />
          </div>
        </div>
      </section>
    </>
  );
}

export default OurPlatform;
